import { MOBILE_BREAKPOINT, LAPTOP_BREAKPOINT } from 'helpers/responsive'
import styled, { css } from 'styled-components'
import { Button } from '@material-ui/core'
import { StyledButton as StyledButtonComponent } from 'components/common/Button/Button.styles'
import {
  BLACK_RGB,
  PURPLE,
  RED,
  WHITE,
  GRAY_INFO,
  MAIN_TEXT,
  GRAY5,
  PRIMARY_TEXT,
  PRIMARY_TEXT_RGB,
  GRAY2,
} from 'constants/colors'
import { GeneralTriggerStyles } from 'routes/App/Apps/JobsTriggers/styles'
import { UsersFilterButton } from '../SelectedOtherFiltersDropdown/SelectedOtherFiltersDropdown.styles'
import { StyledSelectInput } from '../Inputs/styles'
import { Flex } from '../styles'

export const StyledSwitch = styled.div`
  margin-left: auto;
`

export const StyledActionSection = styled(Flex)`
  position: sticky;
  bottom: 0;
  border: solid ${GRAY_INFO};
  background: ${WHITE};
  border-width: 1px 0 0;
  background: ${WHITE};
`

export const StyledButton = styled(Button)`
  padding: 8px 14px;
  border-radius: 8px;
  position: relative;
  background: transparent;
  border: 1px solid ${GRAY_INFO};
  min-width: 0;
  white-space: nowrap;
  text-align: left;
  text-transform: capitalize;

  &:hover {
    background: ${GRAY_INFO};
  }

  &.primary {
    background: ${PURPLE};
    border-color: ${PURPLE};
    color: ${WHITE};

    &:hover {
      background: ${PURPLE};
      border-color: ${PURPLE};
      color: ${WHITE};
    }
  }

  &.Mui-disabled {
    opacity: 0.7;
  }
`

export const StyledButtonHolder = styled(Flex)`
  width: 100%;
  padding: 20px 24px;
  border: solid ${GRAY_INFO};
  border-width: 1px 0 0;
  background: ${WHITE};
  margin-top: -1px;

  ${StyledButtonComponent} {
    margin-right: 11px;

    &:last-child {
      margin-right: 0;
    }
  }
`

export const StyledModalBoxSection = styled.div<{ noBorder?: boolean }>`
  padding: 24px 16px 24px 24px;
  border: solid ${GRAY_INFO};
  border-width: 0 0 1px;

  .MuiCollapse-wrapperInner {
    margin-top: 16px;
  }

  ${({ noBorder }) =>
    noBorder &&
    css`
      border-width: 0;
    `}
`

export const StyledModal = styled(Flex)<{
  customWidth?: string
  opened?: boolean
  isNewHeader?: boolean
}>`
  position: fixed;
  background: ${WHITE};
  top: 0;
  bottom: 0;
  right: -440px;
  width: 440px;
  z-index: 1251;
  transition: 0.3s;
  overflow-y: auto;
  border-radius: 16px 0 0 16px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    right: -100vw;
    width: 100vw;
    ${({ opened }) =>
      opened &&
      css`
        right: 0;
      `}
  }
  
  ${({ isNewHeader }) =>
    isNewHeader &&
    css`
      ${StyledModalBoxSection} {
        @media (max-width: ${LAPTOP_BREAKPOINT}px) {
          &:first-child {
            padding-right: 52px;
          }
        }
        @media (max-width: ${MOBILE_BREAKPOINT}px) {
          &:first-child {
            padding: 16px 52px;
          }
        }
      }
    `}
  
  ${({ customWidth }) =>
    customWidth &&
    css`
      right: -${customWidth};
      width: ${customWidth};
    `}

  ${({ opened }) =>
    opened &&
    css`
      right: 0;
    `}

  ${StyledSelectInput} {
    .MuiFormControl-root {
      max-width: 155px;
    }
  }

  .modal-box-title {
    font-weight: 600;

    &-holder {
      margin: 0;
    }
  }

  ${StyledSelectInput},
  .MuiTextField-root {
    margin: 4px 0 4px 8px;
  }

  ${GeneralTriggerStyles}
`

export const StyledSubModal = styled(StyledModal)`
  z-index: 1252;
`

export const StyledSitesSearchField = styled.div`
  > .MuiTextField-root {
    display: block;
    margin: 0 0 16px;

    .MuiInput-root {
      width: 100%;
    }
  }
`

export const StyledFormSection = styled.div`
  flex: 1;
`

export const StyledModalTitle = styled.div`
  font-weight: 600;
`

export const StyledModalSubtitle = styled.div`
  font-weight: 600;
  opacity: 0.5;
  margin-bottom: 24px;
`

export const StyledSiteTitle = styled.div`
  opacity: 0.6;
  margin-bottom: 16px;
`

export const StyledTasksAssignmentHolder = styled.div`
  border: 1px solid ${GRAY2};
  border-radius: 12px;
  margin-bottom: 16px;
`

export const StyledTaskAssignmentSection = styled(Flex)`
  border-bottom: 1px solid ${GRAY2};
  padding: 16px;

  &:last-child {
    border-bottom: none;
  }

  ${UsersFilterButton} {
    > button {
      width: 180px;
      margin: 0;
    }
  }
`

export const StyledTaskAssignmentTitle = styled.div`
  width: 100%;
`

export const StyledModalCloseButton = styled.div`
  position: relative;
  width: 20px;
  min-width: 20px;
  height: 20px;
  min-height: 20px;
  cursor: pointer;
  margin-left: 24px;

  &:before,
  &:after {
    position: absolute;
    content: '';
    top: 50%;
    left: 0;
    right: 0;
    height: 2px;
    background: ${GRAY5};
  }

  &:before {
    transform: translateY(-50%) rotateZ(45deg);
  }

  &:after {
    transform: translateY(-50%) rotateZ(-45deg);
  }
`

export const StyledModalBackButton = styled.div`
  position: relative;
  margin-right: 16px;
  width: 14px;
  cursor: pointer;

  &:before {
    position: absolute;
    content: '';
    left: -16px;
    top: -10px;
    right: -16px;
    bottom: -10px;
  }

  svg {
    width: 100%;
    transform: rotateZ(180deg);

    path {
      stroke: ${PRIMARY_TEXT};
    }
  }
`

export const StyledErrorMessageHolder = styled.div`
  position: relative;
  padding: 16px 24px 16px 48px;
  color: ${RED};
  background: ${WHITE};

  svg {
    position: absolute;
    top: 16px;
    left: 24px;

    path {
      stroke: ${RED};
    }
  }
`

export const StyledTitle = styled.div<{
  expandable?: boolean
  opened?: boolean
  marginBottom?: string
}>`
  position: relative;
  padding-left: 24px;
  margin-left: -24px;
  font-weight: 500;
  line-height: 20px;
  ${({ marginBottom }) =>
    marginBottom &&
    css`
      margin-bottom: ${marginBottom}px;
    `}

  ${({ expandable, opened }) =>
    expandable &&
    css`
      cursor: pointer;

      &:after {
        position: absolute;
        content: '';
        top: 50%;
        right: 12px;
        width: 6px;
        height: 6px;
        border: solid ${MAIN_TEXT};
        border-width: 0 1px 1px 0;
        transform: translateY(-6px) rotateZ(45deg);
      }

      &:hover {
        color: ${PURPLE};

        &:after {
          border-color: ${PURPLE};
        }

        svg {
          path,
          rect {
            stroke: ${PURPLE};
          }
        }
      }

      ${opened &&
      css`
        &:after {
          transform: translateY(-50%) rotateZ(-135deg);
        }
      `}
    `}

  svg {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
`

export const StyledTitleHint = styled.span`
  color: rgba(${PRIMARY_TEXT_RGB}, 0.6);
  font-weight: 400;
  margin-left: 8px;
  display: inline-flex;
`

export const StyledRuleSettings = styled.div`
  padding-left: 24px;
`

export const StyledName = styled.div<{
  isDisabled?: boolean
  marginBottom?: number
  width?: number
}>`
  text-transform: capitalize;

  ${({ width }) =>
    width &&
    css`
      width: ${width}px;
    `}

  ${({ marginBottom }) =>
    marginBottom &&
    css`
      margin-bottom: ${marginBottom}px;
    `}

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      opacity: 0.5;
    `}
`

export const StyledCondition = styled(Flex)<{ marginBottom?: number }>`
  ${({ marginBottom }) =>
    marginBottom &&
    css`
      margin-bottom: ${marginBottom || 8}px;
    `}

  &:last-child {
    margin-bottom: 0;
  }

  .MuiTextField-root,
  ${StyledSelectInput} {
    + ${StyledName} {
      margin-left: 8px;
    }
  }
`

export const StyledModalOverlay = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(${BLACK_RGB}, 0.3);
  z-index: 1250;

  &.closed {
    display: none;
  }
`
